import { EDrawingActionType } from './types';
import { actionGenerator } from '../../../common/utils/redux/actionGenerator';

export const finishDrawing = actionGenerator<EDrawingActionType.DrawingFinished>(EDrawingActionType.DrawingFinished);
